// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3AOU-","title":"Images45_title__2FAK6","images":"Images45_images__2Pxu5"};